import React from "react"
import styles from "./spacing.module.scss"

export const WithVerticalSpacing: React.FC = ({children}) => {
  return <div className={styles.VerticalSpacing}>
    {children}
  </div>
}